(function () {
	Vue.component('nominow-input-date', {
		model: {
			prop: 'value',
			event: 'change'
		},
		props: {
			value: {
				type: String
			},
			label: {
				type: String,
				required: true,
				default: 'Label'
			},
			name: {
				type: String,
				required: false
			},
			required: {
				type: Boolean,
				required: false
			},
			regex: {
				type: String,
				required: false
			},
			regexMessage: {
				type: String,
				required: false
			},
			css: {
				type: String,
				required: false
			},
			options: {
				type: Object,
				required: false
			},
			nomui: {
				type: Boolean,
				required: false
			}
		},
		data: function () {
			return {
				curVal: this.value
			};
		},
		template: `
    <div class="field" :class="{'mui-textfield' : (!nomui)}">
    <input type="text" :class="css" :name="name || label" v-model="curVal" @blur="$emit('change', curVal)" @input="$emit('change', curVal)" :data-val="(required || regex ? 'true' : null)" :data-val-required="required ? 'Required' : ''" :data-val-regex="regexMessage" :data-val-regex-pattern="regex" />
    <label>{{label}}</label>
    </div>
    `,
		mounted: function () {
			// activate the plugin when the component is mounted.
			window.initDatepickerOnElement($('input', this.$el), this.options);
		},
		methods: {
			setVal: function (val) {
				this.curVal = val;
				this.$emit('change', this.curVal);
				$('input', this.$el)[0]._flatpickr.setDate(this.curVal, true);
			}
		},
		watch: {
			// when the value fo the input is changed from the parent,
			// the value prop will update, and we pass that updated value to the plugin.
			value: function (newVal) {
				//console.log('new value for date', newVal);
				this.curVal = newVal;
				$('input', this.$el)[0]._flatpickr.setDate(newVal, true);
			}
		}
	});
})();
